module.exports = __webpack_public_path__ + "media/img/pages/companies/pmi-c636d1ce4ade1a94a974d5ad8f7937d5.png";